import { query, getBranding } from "sinao-corejs";

const actions = {
	async branding() {
		const brand = await getBranding();
		return brand;
	},
	async checkIfUserExist(_, email) {
		return query({
			operationId: "auth.login",
			data: {
				email,
				password: "_"
			}
		});
	},
	async login(_, { email, password }) {
		return query({
			operationId: "auth.login",
			data: {
				email,
				password
			}
		});
	},
	async register(_, { email, password, cgu, metadata }) {
		return query({
			operationId: "account.create",
			data: {
				email,
				password,
				cgu,
				metadata
			}
		});
	},
	async updateUser(_, { firstname, lastname, token }) {
		return query({
			operationId: "account.update",
			token,
			data: {
				firstname,
				lastname
			}
		});
	},
	async createApp(_, { appName, token, domain, size }) {
		return query({
			operationId: "app.create",
			token,
			params: {
				organization_name: appName,
				hostname_alias: domain,
				organization_size: size,
				"expand[0]": "subscription"
			}
		});
	},
	async updateOrganization(_, { appId, token, phoneNumber, industry, size }) {
		return query({
			operationId: "app.organization.update",
			token,
			params: {
				appId
			},
			data: {
				number_of_employees: size,
				industry,
				headquarters: {
					phone: phoneNumber
				}
			}
		});
	},
	async updateAppSettings(_, { appId, token, data }) {
		return query({
			operationId: "app.settings.update",
			token,
			params: {
				appId
			},
			data: {
				settings: {
					data,
					sinao_version: "24"
				}
			}
		});
	},
	async activateSponsorship(_, { appId, token, referrer_id, email }) {
		return query({
			operationId: "app.sponsorship.activate",
			token,
			params: {
				appId
			},
			data: {
				referrer_app_id: referrer_id,
				recipient: email
			}
		});
	}
};

export default actions;
